'use strict';

function fInitScrollSpy() {
    const oScrollspyObjects = document.querySelectorAll('.js-scrollspy');

    function initScrollspy(el) {
        const oScrollspyNav = el.querySelector('.js-scrollspy-nav');
        const oScrollspyNavVertical = el.querySelector('.js-scrollspy-nav-inline');
        const aScrollspyNavItems = el.querySelectorAll('.js-scrollspy-button');
        const aScrollspySections = document.querySelectorAll('.js-scrollspy-section, section[id]');
        const iNavOffset = oScrollspyNav && offset(oScrollspyNav);

        function fToggleStickyNav (iScrollPosition) {
            if (iScrollPosition > iNavOffset.top - 100) {
                oScrollspyNav.classList.add('is-sticky');
            } else {
                oScrollspyNav.classList.remove('is-sticky');
            }
        }

        function fCheckiScrollPosition () {
            let iScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;

            if (oScrollspyNav) {
                fToggleStickyNav(iScrollPosition);
            }

            for(let i = 0; i < aScrollspySections.length; i+=1) {
                if((aScrollspySections[i].getBoundingClientRect().top - 150) + (window.scrollY || window.pageYOffset) <= iScrollPosition) {
                    for(let p = 0; p < aScrollspyNavItems.length; p += 1) {
                        let oItem = aScrollspyNavItems[p];

                        if(oItem.classList.contains('is-active')){
                            oItem.classList.remove('is-active');
                        }

                        if(oItem.getAttribute('href') === `#${aScrollspySections[i].id}` && !oItem.classList.contains('is-active')) {
                            oItem.classList.add('is-active');

                            if (oScrollspyNavVertical) {
                               if (p === 0) {
                                    oScrollspyNavVertical.scrollLeft = 0;
                               } else {
                                    oScrollspyNavVertical.scrollLeft += oItem.getBoundingClientRect().left - 15;
                               }
                            }
                        }
                    }
                }
            }
        }

        function fScrollToSection (event) {
            const oButton = event.target.closest('.js-scrollspy-button');
            const oScrollDestEl = document.getElementById(oButton.getAttribute('href').slice(1));

            scrollIt(offset(oScrollDestEl).top - 130, 400, 'easeInQuad', 0);
            event.preventDefault();
        }

        for (let p = 0; p < aScrollspyNavItems.length; p += 1) {
            aScrollspyNavItems[p].addEventListener('click', function (event) {
                fScrollToSection(event);
            });
        }

        window.onscroll = () => fCheckiScrollPosition();
        fCheckiScrollPosition();
    }

    oScrollspyObjects.forEach(el => {
        initScrollspy(el);
    });
}
